import { BTCSPrimaryColor } from './constants';
import { baseMUITheme } from './theme';

export const paletteLight = {
  type: 'light',
  background: {
    default: '#F9F9F9',
    paper: '#ffffff',
  },
  common: {
    black: '#262626',
    white: '#ffffff',
  },
  text: {
    primary: '#262626',
    secondary: '#262626',
  },
  contrastThreshold: 1,
  tonalOffset: 1,
  grey: baseMUITheme.palette.grey,
  getContrastText: baseMUITheme.palette.getContrastText,
  augmentColor: baseMUITheme.palette.augmentColor,
  icon: {
    main: '#262626',
    dark: '#231F20',
    light: '#f4f4f4',
    contrastText: '#404040',
  },
  primary: {
    main: BTCSPrimaryColor,
    contrastText: '#fff',
    light: '',
    dark: '',
  },
  secondary: {
    main: '#AAAAAA',
    contrastText: '#fff',
    light: '',
    dark: '',
  },
  error: {
    main: '#E23B58',
    contrastText: '#fff',
    light: '#F28699',
    dark: '#C61D3A',
  },
  success: {
    main: '#228833',
    dark: '#228833',
    light: '#73a87b',
    contrastText: '#fff',
  },
  info: {
    main: '#a2a2a2',
    dark: '#7c7c7c',
    light: '#a2a2a2',
    contrastText: '#fff',
  },
  warning: {
    main: '#E9C569',
    light: '#EAD7A8',
    dark: '#DEAE30',
    contrastText: '#fff',
  },
  danger: {
    main: '#bb2233',
    dark: '#bb2233',
    light: '#c96d77',
    contrastText: '#fff',
  },
  divider: '#f3f3f3',
};
